export const UPDATE_CATEGORIE = 'categorie:updateCategorie';

export function updateCategorie(newCat) {
    return {
        type: UPDATE_CATEGORIE,
        payload: newCat
    }
}


// WEBPACK FOOTER //
// ./src/container/actions/categorie-action.js